module.exports = __webpack_public_path__ + "static/0-06074278032b643db96f6e085085d5c8.jpg";